import { cn } from "tailwind-variants";
import "./List.scss";

function List({ long, children, ...restProps }) {
  return (
    <ul
      {...restProps}
      className={cn("list scope-005cf356", restProps.className, { "list--long": long })}
    >
      {children}
    </ul>
  );
}

export default List;
